import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import { mandatoryTag } from '@/containers/SubscriptionFormPageNew/isMandatory'
import useLastHolderFields from './useLastHolderFields'
import PropertyDate from './PropertyDate'

const LastHolderFields = () => {
  const { t, errors, isEditable, lastHolderName, lastHolderCf, hidden, updateAddress } = useLastHolderFields()

  if (hidden) return null

  return (
    <>
      <SDFormControl error={getError('last_holder_name', errors)}>
        <SDInput
          label={mandatoryTag + t('subscriptionForm:address_module.last_holder_fields.name')}
          disabled={isEditable === false}
          currentValue={lastHolderName ?? ''}
          onBlur={(value: string | null) => updateAddress({ last_holder_name: value ?? '' })}
          error={getError('last_holder_name', errors)}
          overrides={undefined}
          status={undefined}
          outerOnchange={undefined}
        />
      </SDFormControl>

      <SDFormControl error={getError('last_holder_cf', errors)}>
        <SDInput
          label={mandatoryTag + t('subscriptionForm:address_module.last_holder_fields.codice_fiscale')}
          disabled={isEditable === false}
          currentValue={lastHolderCf ?? ''}
          onBlur={(value: string | null) => updateAddress({ last_holder_cf: value ?? '' })}
          error={getError('last_holder_cf', errors)}
          overrides={undefined}
          status={undefined}
          outerOnchange={undefined}
        />
      </SDFormControl>

      <PropertyDate />
    </>
  )
}

export default LastHolderFields
